import { render, staticRenderFns } from "./TheMinCorpoChat.vue?vue&type=template&id=7dfc0382&scoped=true"
import script from "./TheMinCorpoChat.vue?vue&type=script&lang=js"
export * from "./TheMinCorpoChat.vue?vue&type=script&lang=js"
import style0 from "./TheMinCorpoChat.vue?vue&type=style&index=0&id=7dfc0382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfc0382",
  null
  
)

export default component.exports